query GetEvents(
  $page: Int
  $limit: Int
  $status: EventStatusEnum
  $eventType: EventTypeEnum
  $period: EventPeriodEnum
  $city: String
  $search: String
) {
  events(
    page: $page
    limit: $limit
    status: $status
    eventType: $eventType
    period: $period
    city: $city
    search: $search
  ) {
    collection {
      id
      strapiSlug
      status
      eventType
      registrationMode
      title
      startsAt
      endsAt
      timezone
      locationCity
      capacity
      waitlistEnabled
      confirmedCount
      offeredCount
      waitlistedPeopleCount
      waitlistedPartiesCount
      remainingCapacity
      overCapacity
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
